import styled, { css } from "styled-components";

export const Container = styled.div`
    padding: 1rem;
    background: #7A05A7;
    color: #FFF5FF;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    transition: filter 0.2s ease;

    display: flex;
    justify-content: center;

    svg{
        font-size: 1.1rem;
        margin-right: 0.1rem;
    }

    &:hover{
        filter: brightness(0.9);
    }
   
    @media (min-width: 960px){
        cursor: pointer;
    }

    ${props => props.breathButton && css`
        animation-duration: 0.65s;
        animation-name: breathbutton;
        animation-iteration-count: 7;

        @keyframes breathbutton{
            0%{background: #7A05A799}
            25%{background: #7A05A7B3}
            50%{background: #7A05A7CC}
            75%{background: #7A05A7E6}
            100%{background: #7A05A7}       
        }
    `}
`